const STRENGTH_LABELS = ["", "Weak", "Fair", "Strong", "Very strong"];

// Bar colour per strength level, indexed like STRENGTH_LABELS.
export const STRENGTH_COLORS = ["", "var(--danger)", "var(--warning)", "var(--info)", "var(--accent)"];

// One point each for length >= 8, an uppercase letter, a digit and a symbol.
export function getPasswordStrength(password: string): { level: number; label: string } {
  if (!password) return { level: 0, label: "" };
  let score = 0;
  if (password.length >= 8) score++;
  if (/[A-Z]/.test(password)) score++;
  if (/[0-9]/.test(password)) score++;
  if (/[^A-Za-z0-9]/.test(password)) score++;
  return { level: score, label: STRENGTH_LABELS[score] };
}
